import script from "./HeadView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadView.vue?vue&type=script&setup=true&lang=js"

import "./HeadView.vue?vue&type=style&index=0&id=56a15229&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a15229"]])

export default __exports__